import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import clsx from "clsx";
import MenuCart from "./sub-components/MenuCart";
import { useProducts } from "../../hooks/productsHooks/useProducts";
import SearchItems from "./sub-components/SearchItems";
import { HiXMark } from "react-icons/hi2";
import { useTranslation } from "react-i18next";
import { t } from "i18next";

const IconGroup = ({ iconWhiteClass }) => {
  const { pathname } = useLocation();
  const [user, setUser] = useState(null);
  const [search, setSearch] = useState();
  const { data: products } = useProducts();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("token")))
      setUser(JSON.parse(localStorage.getItem("token"))?.user);
  }, [pathname]);

  const changeLanguageTrigger = (e) => {
    const languageCode = e.target.value;
    i18n.changeLanguage(languageCode);
  };

  const handleClick = (e) => {
    e.currentTarget.nextSibling.classList.toggle("active");
  };
  const searchContentToggle = () => {
    const searchContent = document.querySelector(".search-content");
    searchContent.classList.remove("active");
  };

  const triggerMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector(
      "#offcanvas-mobile-menu"
    );
    offcanvasMobileMenu.classList.add("active");
  };
  const { compareItems } = useSelector((state) => state.compare);
  const { wishlistItems } = useSelector((state) => state.wishlist);
  const { cartItems } = useSelector((state) => state.cart);

  return (
    <div className={clsx("header-right-wrap", iconWhiteClass)}>
      <div className="language-currency-wrap align-items-center d-md-block d-none">
        <div className="same-language-currency language-style">
          <span className="fs-6 fw-bold">
            {i18n.resolvedLanguage === "ar"
              ? "العربية"
              : i18n.resolvedLanguage === "en"
              ? "English"
              : ""}{" "}
            <i className="fa fa-angle-down" />
          </span>
          <div className="lang-car-dropdown">
            <ul>
              <li style={{ textAlign: "start" }}>
                <button
                  style={{ textAlign: "start" }}
                  value="ar"
                  onClick={(e) => changeLanguageTrigger(e)}
                >
                  العربية
                </button>
              </li>
              <li style={{ textAlign: "start" }}>
                <button
                  style={{ textAlign: "start" }}
                  value="en"
                  onClick={(e) => changeLanguageTrigger(e)}
                >
                  English
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="same-style header-search d-none d-lg-block">
        <button className="search-active" onClick={(e) => handleClick(e)}>
          <i className="pe-7s-search" />
        </button>
        <div className="search-content relative">
          <form onSubmit={(e) => e.preventDefault()}>
            <input
              onChange={(e) => setSearch(e.target.value)}
              type="text"
              placeholder={t("search")}
            />
            {search && (
              <HiXMark
                onClick={() => {
                  setSearch("");
                }}
                style={{
                  cursor: "pointer",
                  fontSize: "20px",
                  color: "#000",
                  width: "20px",
                  height: "20px",
                  top: "50%",
                  insetInlineEnd: "10px",
                  transform: "translateY(-50%)",
                }}
                size={20}
                className="position-absolute"
                color="red"
              ></HiXMark>
            )}
          </form>
          {search && (
            <div
              className="position-absolute w-100 bg-white shadow p-2"
              style={{
                top: "100%",
                insetInlineEnd: 0,
                height: "300px",
                overflow: "auto",
              }}
            >
              {products?.products?.filter((product) => {
                return product.name
                  .toLowerCase()
                  .includes(search?.toLowerCase());
              })?.length ? (
                products?.products
                  ?.filter((product) => {
                    return product.name
                      .toLowerCase()
                      .includes(search?.toLowerCase());
                  })
                  ?.map((product) => (
                    <SearchItems product={product} key={product.id} />
                  ))
              ) : (
                <div className="d-flex justify-content-center flex-column align-items-center mt-4">
                  <svg
                    width={30}
                    height={30}
                    viewBox="0 -0.5 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="SVGRepo_bgCarrier" strokeWidth={0} />
                    <g
                      id="SVGRepo_tracerCarrier"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <g id="SVGRepo_iconCarrier">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5.5 11.493C5.50364 8.39226 7.69698 5.72579 10.7388 5.12416C13.7807 4.52253 16.8239 6.15327 18.0077 9.0192C19.1915 11.8851 18.186 15.1881 15.6063 16.9085C13.0265 18.6288 9.59077 18.2874 7.4 16.093C6.18148 14.8725 5.49799 13.2177 5.5 11.493Z"
                        stroke="#000000"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />

                      <path
                        d="M16.062 16.568L19.5 19.993"
                        stroke="#000000"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />

                      <path
                        d="M10.5303 8.96271C10.2374 8.66982 9.76256 8.66982 9.46967 8.96271C9.17678 9.25561 9.17678 9.73048 9.46967 10.0234L10.5303 8.96271ZM11.4697 12.0234C11.7626 12.3163 12.2374 12.3163 12.5303 12.0234C12.8232 11.7305 12.8232 11.2556 12.5303 10.9627L11.4697 12.0234ZM12.5303 10.9627C12.2374 10.6698 11.7626 10.6698 11.4697 10.9627C11.1768 11.2556 11.1768 11.7305 11.4697 12.0234L12.5303 10.9627ZM13.4697 14.0234C13.7626 14.3163 14.2374 14.3163 14.5303 14.0234C14.8232 13.7305 14.8232 13.2556 14.5303 12.9627L13.4697 14.0234ZM12.5303 12.0234C12.8232 11.7305 12.8232 11.2556 12.5303 10.9627C12.2374 10.6698 11.7626 10.6698 11.4697 10.9627L12.5303 12.0234ZM9.46967 12.9627C9.17678 13.2556 9.17678 13.7305 9.46967 14.0234C9.76256 14.3163 10.2374 14.3163 10.5303 14.0234L9.46967 12.9627ZM11.4697 10.9627C11.1768 11.2556 11.1768 11.7305 11.4697 12.0234C11.7626 12.3163 12.2374 12.3163 12.5303 12.0234L11.4697 10.9627ZM14.5303 10.0234C14.8232 9.73048 14.8232 9.25561 14.5303 8.96271C14.2374 8.66982 13.7626 8.66982 13.4697 8.96271L14.5303 10.0234ZM9.46967 10.0234L11.4697 12.0234L12.5303 10.9627L10.5303 8.96271L9.46967 10.0234ZM11.4697 12.0234L13.4697 14.0234L14.5303 12.9627L12.5303 10.9627L11.4697 12.0234ZM11.4697 10.9627L9.46967 12.9627L10.5303 14.0234L12.5303 12.0234L11.4697 10.9627ZM12.5303 12.0234L14.5303 10.0234L13.4697 8.96271L11.4697 10.9627L12.5303 12.0234Z"
                        fill="#000000"
                      />
                    </g>
                  </svg>

                  <p className="mb-0 fw-medium">{t("no_results_found")}! </p>
                </div>
              )}{" "}
            </div>
          )}
        </div>
      </div>
      <div className="same-style account-setting d-md-block d-none">
        <button
          aria-label="login page button"
          className="account-setting-active p-0"
          onClick={(e) => handleClick(e)}
        >
          {user ? (
            <div className="d-flex gap-1 align-items-center">
              {user.profile_picture ? (
                <img
                  src={
                    !user.profile_picture
                      ? "/assets/user-alt-1-svgrepo-com.svg"
                      : `${import.meta.env.VITE_REACT_APP_API_URL}/${
                          user.profile_picture
                        }`
                  }
                  alt="profile"
                  className="rounded-circle object-fit-cover"
                  width={"35px"}
                  height={"35px"}
                />
              ) : (
                <i className="pe-7s-user" />
              )}

              <p className="">{user?.name}</p>
            </div>
          ) : (
            <i className="pe-7s-user" />
          )}
        </button>
        <div className="account-dropdown">
          <ul>
            {!user ? (
              <li>
                <Link to={"/login-register"} style={{ textAlign: "start" }}>
                  {t("login")}
                </Link>
              </li>
            ) : (
              <li>
                <Link to={"/my-account"} style={{ textAlign: "start" }}>
                  {t("my_account")}
                </Link>
                <Link
                  to={""}
                  onClick={() => {
                    setUser(null);
                    localStorage.removeItem("token");
                    localStorage.removeItem("tokenExpiryTime");
                  }}
                  style={{ textAlign: "start" }}
                >
                  {t("logout")}
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
      <div className="same-style header-compare">
        <Link to={"/compare"}>
          <i className="pe-7s-shuffle" />
          <span className="count-style">
            {compareItems && compareItems.length ? compareItems.length : 0}
          </span>
        </Link>
      </div>
      <div className="same-style header-wishlist">
        <Link to={"/wishlist"}>
          <i className="pe-7s-like" />
          <span className="count-style">
            {wishlistItems && wishlistItems.length ? wishlistItems.length : 0}
          </span>
        </Link>
      </div>
      <div className="same-style cart-wrap d-none d-lg-block">
        <button className="icon-cart" onClick={(e) => handleClick(e)}>
          <i className="pe-7s-shopbag" />
          <span className="count-style">
            {cartItems && cartItems.length ? cartItems.length : 0}
          </span>
        </button>
        {/* menu cart */}
        <MenuCart />
      </div>
      <div className="same-style cart-wrap d-block d-lg-none">
        <Link className="icon-cart" to={"/cart"}>
          <i className="pe-7s-shopbag" />
          <span className="count-style">
            {cartItems && cartItems.length ? cartItems.length : 0}
          </span>
        </Link>
      </div>
      <div className="same-style mobile-off-canvas d-block d-md-none">
        <button
          className="mobile-aside-button d-flex align-items-center"
          onClick={() => triggerMobileMenu()}
        >
          <i className="pe-7s-menu" />
        </button>
      </div>
    </div>
  );
};

IconGroup.propTypes = {
  iconWhiteClass: PropTypes.string,
};

export default IconGroup;
